import { render, staticRenderFns } from "./ProjectSelectTab.vue?vue&type=template&id=37e1f3d0&scoped=true&"
import script from "./ProjectSelectTab.vue?vue&type=script&lang=js&"
export * from "./ProjectSelectTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSelectTab.vue?vue&type=style&index=0&id=37e1f3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1f3d0",
  null
  
)

export default component.exports